import tw, { styled } from 'twin.macro';

export const StyledSection = styled.section`
  ${tw`lg:px-0`};
`;

export const StyledContainer = styled.div`
  ${tw`container`}
  ${tw`container-stack-context`};
`;

export const StyledRichText = styled.div`
  ${tw`font-inter`};

  // NOTE: Let the Building Blocks manage the spacing between them by avoiding margin on the first child
  & > * {
    ${tw`first:mt-0`};
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    ${tw`font-semi-bold`};
    ${tw`text-primary-p1`};
  }

  h1 {
    ${tw`text-mobile-heading-l md:text-heading-l`}
  }

  h2 {
    ${tw`text-mobile-heading-m md:text-heading-m`}
  }

  h3 {
    ${tw`text-mobile-heading-xs md:text-heading-xs`}
  }

  h4 {
    ${tw`font-regular`}
    ${tw`text-body-l text-neutrals-n8`}
  }

  h5,
  h6 {
    ${tw`font-regular`}
    ${tw`text-body-m text-neutrals-n8`}
  }

  h1,
  h2 {
    ${tw`mt-7 mb-3`}
  }

  h3 {
    ${tw`mt-[12px] mb-2`};
  }

  h4,
  h5,
  h6 {
    ${tw`my-1`}
  }

  ol,
  ul {
    ${tw`text-body-l text-primary-p1`}
    ${tw`mt-2 mb-3`}
  }

  figure {
    ${tw`my-7`}
  }

  p {
    ${tw`text-body-l text-primary-p1`}
    ${tw`my-[14px]`}

    & + .table-responsive {
      ${tw`mt-8 md:mt-10`}
    }
  }

  ol,
  ul {
    ${tw`pl-3`}
    ${tw`list-none`}
    ${tw`flex flex-col gap-[12px]`}
    li {
      &::marker {
        ${tw`text-secondary-s1 text-tag-l font-bold`}
      }
    }
  }

  ul > li {
    ${tw`list-disc`}
    ul > li {
      ${tw`list-[circle]`}
      ul > li {
        ${tw`list-disc`}
      }
    }
  }

  ol > li {
    ${tw`list-decimal`}
  }

  a {
    ${tw`text-secondary-s1`}
    ${tw`hover:underline no-underline`}
  }

  figcaption {
    ${tw`mt-[12px]`}
    ${tw`font-medium`}
    ${tw`text-neutrals-n6 text-body-s`}
  }

  p > code,
  li > code {
    ${tw`py-[3px] px-[5px]`}
    ${tw`bg-neutrals-n3`}
  }

  pre {
    ${tw`w-full`}
    ${tw`m-0`}
    ${tw`rounded`}
    ${tw`text-neutrals-n7`}
    ${tw`whitespace-pre-wrap`}

    counter-reset: linecounter;

    & .line-num {
      ${tw`min-w-[3ch]`}
      ${tw`inline-block`}
      ${tw`opacity-50`}

      &::before {
        counter-increment: linecounter;
        content: counter(linecounter);
      }
    }

    & mark.green {
      background-color: #033a16;
      color: #aff5b4;
      & span {
        color: #aff5b4 !important;
      }
    }

    & mark.yellow {
      background-color: yellow;
      color: black;
      & span {
        color: black !important;
      }
    }

    & mark.red {
      background-color: #67060c;
      color: #ffdcd7;
      & span {
        color: #ffdcd7 !important;
      }
    }
  }

  code {
    ${tw`text-tag-m`}
    ${tw`tracking-normal`}
    ${tw`rounded`}
  }
`;
